import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Backdrop, Box, Checkbox, CircularProgress, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { changeUserRole } from 'src/redux/actions/User';
import toast from 'react-hot-toast';

export default function ChangeRoleDialog({open, setOpen, currentUser}) {

    const [role, setRole] = React.useState('')
    const [shouldNotify, setShouldNotify] = React.useState(false)

    const [isLoadingOpen, setIsLoadingOpen] = React.useState(false)

    const dispatch = useDispatch()

    React.useEffect(() => {
        setRole(currentUser.role)
    }, [])

    const sendSetStatus = async () => {
        setIsLoadingOpen(true)

        const result = await dispatch(changeUserRole({
            userId: currentUser._id,
            role: role,
            shouldNotify: shouldNotify
        }))

        console.log(result)

        if(result){
            toast.success("Changed role successfully")
        } else {
            toast.error("Error while changing role")
        }
        setIsLoadingOpen(false)
        setOpen(false)
    }

  return (
    <React.Fragment>
    {/* <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isLoadingOpen}
        onClick={() => {}}
    >
        <CircularProgress color="inherit" />
    </Backdrop>         */}
      <Dialog
        maxWidth={"sm"} 
        fullWidth
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="change-role-dialog"
        aria-describedby="dialog-for-changing-user-role"
      >
        <DialogTitle id="change-role-dialog">
          Change user's role
        </DialogTitle>
        <DialogContent sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px"
        }}>
          <DialogContentText id="dialog-for-changing-user-role">
            <Typography variant="subtitle1" sx={{
                textAlign: "center"
            }}>Current user's role: {currentUser.role}</Typography>
          </DialogContentText>
            <FormControl fullWidth size="small">
                <InputLabel id="role-select">Role</InputLabel>
                <Select
                    labelId="role-select"
                    id="demo-simple-select"
                    value={role}
                    label="Age"
                    onChange={(e) => setRole(e.target.value)}
                >
                    <MenuItem value={'user'}>User</MenuItem>
                    <MenuItem value={'admin'}>Administrator</MenuItem>
                </Select>
            </FormControl>
            <FormGroup>
                <FormControlLabel control={<Checkbox checked={shouldNotify} onChange={(e) => setShouldNotify(e.target.checked)} />} label="Notify user about role change" />
            </FormGroup>          
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpen(false)
            setIsLoadingOpen(false)
          }}>Cancel</Button>
          {isLoadingOpen ? (
            <Box sx={{
                p: 2
            }}>
                <CircularProgress color="primary" size={20} />
            </Box>
          ) : (
              <Button onClick={sendSetStatus} autoFocus>
                Save
              </Button>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
